import React from "react"
import "twin.macro"

const Container = ({ children, ...props }) => {
  return (
    <div
      tw="container mx-auto px-6 lg:max-w-[75rem] xl:(max-w-[75rem] px-0) 2xl:(max-w-[75rem])"
      {...props}
    >
      {children}
    </div>
  )
}

export default Container
